<template>
  <div>
    <!-- 弹窗1开始 -->
    <el-dialog title="关联/清除货位" :visible.sync="dialogVisible" width="700px">
      <el-tabs v-model="activeName">
        <el-tab-pane label="关联货位" name="1">
          <div style="color: red; font-size: 12px; margin-bottom: 16px;">
            使用说明：关联货位用于仓库中存在未关联货位的商品，可通过此操作快捷关联货位；
          </div>

          <div style="display: flex; margin-bottom: 16px;">
            <div class="productImg">
              <img :src="editRow.thumb != '' ? editRow.thumb : require('../../assets/img-default.png')">
            </div>

            <!-- <img :src="scope.row.thumb!='' ? scope.row.thumb : require('../../assets/img-default.png')" /> -->
            <div>
              <div class="cz-product-inventorys-main-infos-name productName">【{{ editRow.companyname }}】{{ editRow.name
                }}
                <span v-if="editRow.spec">[{{ editRow.spec }}]</span>
              </div>
              <div class="cz-product-inventorys-main-infos-number">编号：{{ editRow.number }}</div>
              <div>条形码：{{ editRow.basebarcode }}</div>
            </div>
          </div>

          <el-form :model="dataForm" label-width="100px">
            <el-form-item label="关联仓库">
              <el-select v-model="dataForm.warehouse_id" placeholder="请选择仓库" style="width: 100%;"
                @change="warehouseChange">
                <el-option v-for="item in warehouselists" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联货位">
              <el-input v-model="dataForm.storage_location_name" placeholder="请选择货位" readonly
                @click.native="openLocationDialog">
              </el-input>
            </el-form-item>
          </el-form>

        </el-tab-pane>
        <el-tab-pane label="清除货位" name="2">
          <div style="color: red; font-size: 12px; margin-bottom: 16px;">
            使用说明：清除货位用于仓库中存在商品已经从货位销售清空，可通过此操作快捷清除货位和商品关系;在商品按货位盘点时，剔除掉清除关系的商品不在关联货位中显示。
          </div>

          <div style="display: flex; margin-bottom: 16px;">
            <div class="productImg">
              <img :src="editRow.thumb != '' ? editRow.thumb : require('../../assets/img-default.png')">
            </div>

            <!-- <img :src="scope.row.thumb!='' ? scope.row.thumb : require('../../assets/img-default.png')" /> -->
            <div>
              <div class="cz-product-inventorys-main-infos-name productName">【{{ editRow.companyname }}】{{ editRow.name
                }}
                <span v-if="editRow.spec">[{{ editRow.spec }}]</span>
              </div>
              <div class="cz-product-inventorys-main-infos-number">编号：{{ editRow.number }}</div>
              <div>条形码：{{ editRow.basebarcode }}</div>
            </div>
          </div>

          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <span>可清除货位（仅获取商品库存数量在货位为0的数据</span> 
            已选<span style="color: red;margin: 0 5px;">{{ selections.length }}</span>个 
            <el-button size="small" type="primary" @click="chooseAllLocation" style="margin-left: 20px;">全选</el-button>
          </div>
          <el-table :data="ClearStorageLocations" :border="true" style="width: 100%" size="small">
            <el-table-column label="货位名称" align="center"  prop="full_code"></el-table-column>
            <el-table-column v-if="batchStatus" label="批次号" align="center"  prop="batch_sn"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button v-if="selections.indexOf(scope.row.id) == -1" type="default" size="small" @click="chooseLocation(scope.row)">选择</el-button>
                <el-button v-if="selections.indexOf(scope.row.id) != -1" type="primary" size="small" @click="chooseLocation(scope.row)">已选择</el-button>
              </template>
            </el-table-column>
          </el-table>
          
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button v-if="activeName == 1" size="small" type="primary" @click="submitForm">确定</el-button>
        <el-button v-if="activeName == 2" size="small" type="primary" @click="clearSubmit">保存并删除</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗1结束 -->


    <!-- 弹窗2开始 -->
    <el-dialog title="选择货位" :visible.sync="locationDialog" @close="locationParams.keyword = ''">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input placeholder="请输入搜索关键词" v-model="locationParams.keyword" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="locationSearch()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="locationList" style="width: 100%" v-loading="locationDialogLoading">
        <el-table-column label="货位号" align="left" header-align="center" prop="full_code"></el-table-column>
        <el-table-column label="选择" width="80">
          <template slot-scope="scope">
            <el-button type="primary" size="small" icon="el-icon-check" @click="selectLocation(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <!--分页begin-->
        <el-pagination @size-change="locationPageSizeChange" @current-change="locationPageCurrentChange"
          :current-page="locationParams.p" :page-sizes="[10, 20, 50]" :page-size="locationParams.rollpage"
          layout="total, sizes, prev, pager, next, jumper" :total="locationParams.total">
        </el-pagination>
        <!--分页end-->
      </div>
    </el-dialog>
    <!-- 弹窗2结束 -->
  </div>
</template>
<script>
export default {
  // 修复 props 拼写错误
  props: {
    warehouselists: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false, // 弹窗1显示控制
      activeName: '1',
      editRow: {}, // 存储传入的row数据
      dataForm: {
        act: 'associated_cargo_location',
        warehouse_id: '',
        product_id: '',
        storage_location_id: '',
        storage_location_name: '',
      },
      locationParams: {
        keyword: '',
        rollpage: 10,
        p: 1,
        total: 0
      },
      locationDialog: false,
      locationDialogLoading: false,
      locationList: [],
      ClearStorageLocations: [],
      selections: [],
      batchStatus: false
    }
  },
  methods: {
    clearSubmit() {
      if (this.selections.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择要清除的货位'
        })
        return
      }
      this.$confirm('确认执行清除货位操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const url = this.GLOBAL.domain + "Inventory/index"
          this.$resource(url).save({
            act: 'clear_storage_location',
            token: this.$cookies.get('token'),
            id: this.selections.join(",")
          }).then(res => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.listLoading = false;
            }else{
              this.selections = []
              this.$message.success('清除货位操作成功！');
              this.$emit('refresh')
              this.dialogVisible = false

            }
          })
        })

      
    },
    chooseAllLocation() {
      this.selections = []
      this.ClearStorageLocations.forEach(item => {
        this.selections.push(item.id)
      })
    },
    chooseLocation(row) {
      // 查询this.selections中是否存在row.id，如果没有存在则push进去，有则删除
      var index = this.selections.indexOf(row.id)
      if(index == -1) {
        this.selections.push(row.id)
      } else {
        this.selections.splice(index, 1)
      }
    },
    // 获取清除货位列表
    getLocationList() { 
      const url = this.GLOBAL.domain + "Inventory/index"
      this.$resource(url).save({
        act: 'clear_storage_location_list',
        product_id: this.dataForm.product_id,
        token: this.$cookies.get('token')
      }).then(res => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.listLoading = false;
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            console.log(result, '关联货位列表')
            this.ClearStorageLocations = result
        }
      })
    },
    warehouseChange() {
      this.dataForm.storage_location_name = ''
    },
    openDialog(row) {
      this.batchStatus = localStorage.getItem('batchStatus') === 'true'
      this.activeName = '1'
      this.selections = []
      this.dataForm.warehouse_id = ''
      this.dataForm.storage_location_id = ''
      this.dataForm.storage_location_name = ''
      this.$nextTick(() => { 
        this.editRow = row
        console.log(row, '关联货位')
        this.dataForm.product_id = row.id
        this.getLocationList()
        this.dialogVisible = true
      })
    },
    locationSearch() {
      this.locationParams.p = 1
      this.locationDropdownList()
    },
    openLocationDialog() {
      if (!this.dataForm.warehouse_id) {
        return this.$message.error('请先选择仓库')
      }
      this.locationDropdownList()
      this.locationDialog = true
    },
    locationPageSizeChange(val) {
      this.locationParams.rollpage = val;
      this.locationDropdownList();
    },
    locationPageCurrentChange(val) {
      this.locationParams.p = val;
      this.locationDropdownList();
    },
    selectLocation(row) {
      this.dataForm.storage_location_id = row.id
      this.dataForm.storage_location_name = row.full_code
      this.locationDialog = false
    },

    submitForm() {
      if (!this.dataForm.warehouse_id) {
        this.$message.error('请选择仓库')
        return
      }
      if (!this.dataForm.storage_location_id) {
        this.$message.error('请选择货位')
        return
      }

      const url = this.GLOBAL.domain + "Inventory/index"
      this.$resource(url).save({
        ...this.dataForm,
        token: this.$cookies.get('token')
      }).then(res => {
        if (res.data.Result === 0) {
          this.$message.success('关联货位成功')
          this.dialogVisible = false
          this.$emit('refresh') // 触发父组件刷新
        } else {
          this.$message.error(res.data.Message)
        }
      }).catch(() => {
        this.$message.error('操作失败，请重试')
      })
    },
    locationDropdownList() {
      if (!this.dataForm.warehouse_id) {
        this.$message.error('请先选择收货仓库')
        return
      }
      this.locationDialog = true
      const address_url = this.GLOBAL.domain + "StorageLocation/select_list"
      const send_data = {
        warehouse_id: this.dataForm.warehouse_id,
        token: this.$cookies.get('token'),
        ...this.locationParams
      }
      var resource = this.$resource(address_url);
      this.locationDialogLoading = true
      resource.save(send_data).then((res) => {
        if (res.data.Result > 0) {
          this.locationList = []
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          if (Array.isArray(result.data) && result.data.length > 0) {
            for (const i of result.data) {
              i["id"] = i["id"].toString()
            }
          }
          this.locationList = result.data
          this.locationParams.total = result.total
        }
      }).catch((res) => {
        this.locationList = []
        this.$message.error(this.GLOBAL.errortext);
      }).finally(() => {
        this.locationDialogLoading = false
      })
    }
  }
}
</script>

<style scoped>
.productImg {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  border-radius: 6px;
  border: 1px solid rgba(221, 221, 221, .7);
  overflow: hidden;
  flex-shrink: 0;
}

.productImg img {
  max-width: 100%;
  max-height: 100%;
}

.productName {
  font-size: 14px;
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/inventory/inventoryListBind.vue